export default {
  transaksiPage: (state, getters) => {
    return state.transaksiPage;
  },
  total: (state, getters) => {
    return state.total;
  },
};
